import { FC } from 'react';
import { formatTripBuilderServiceDate, getTripBuilderExpireDateHeaderParts } from 'utils/shared/tripBuilder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

interface TripBuilderHeaderInfoProps {
  proposalId?: number;
  clientName?: string;
  firstServiceDate?: Date;
  expireDate?: string;
  onEditAdditionalInfo?: () => void;
}

const TripBuilderHeaderInfo: FC<TripBuilderHeaderInfoProps> = ({
  proposalId,
  clientName,
  firstServiceDate,
  expireDate,
  onEditAdditionalInfo,
}) => {
  const firstServiceLabel = formatTripBuilderServiceDate(firstServiceDate);
  const expireDateParts = getTripBuilderExpireDateHeaderParts(expireDate);

  return (
    <div className="pr-tb-info text-lh text-sm">
      {proposalId !== undefined && (
        <>
          <span className="pr-tb-info-label">Proposal:</span>
          <span className="text-bold">{proposalId}</span>
        </>
      )}
      {!!clientName && (
        <>
          <span className="pr-tb-info-label">Client:</span>
          <span className="text-bold">{clientName}</span>
        </>
      )}
      {!!firstServiceLabel && (
        <>
          <span className="pr-tb-info-label">First Service:</span>
          <span className="text-bold">{firstServiceLabel}</span>
        </>
      )}
      {expireDateParts && (
        <>
          <span className="pr-tb-info-label">Expire Date:</span>
          <span className="text-bold">
            {!expireDateParts.isExpired && (
              <>
                <span className="color-danger">{expireDateParts.daysLabel}</span>
                {' '}
              </>
            )}
            ({expireDateParts.datePart})
            {onEditAdditionalInfo && (
              <FontAwesomeIcon
                icon={faPencil}
                className="cur-poi ml-5"
                size="xs"
                onClick={onEditAdditionalInfo}
              />
            )}
          </span>
        </>
      )}
    </div>
  );
};

export default TripBuilderHeaderInfo;
